export enum CustomerSearchType {
    CALENDAR = 'CALENDAR',
    LIST = 'LIST',
}
